import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import * as formatters from '../utils/formatters'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const renderValue = (value, { withCents = false, defaultVal }) => {
  return withCents
    ? formatters.formatMoneyWithCents(value, defaultVal)
    : formatters.formatMoney(value, defaultVal)
}

const CurrencyCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(
          _.get(row, field) || row[baseField],
          definition.formatOptions || {}
        )}
      </div>
    </Cell>
  )
}

/**
 * formatOptions for CurrencyCell allow for withCents format along with an optional default value.
 * e.g. formatOptions: {
 *  withCents: true,
 *  defaultVal: '0',
 * }
 */

CurrencyCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      withCents: PropTypes.bool,
      defaultVal: PropTypes.string,
    }),
  }).isRequired,
  data: PropTypes.array,
}

export default CurrencyCell
